import Container from 'src/components/_layout/Container/Container'
import * as Styles from './RichText.style'
import Padder from 'src/components/_layout/Padder/Padder'
import RichTextComponent from 'src/components/atoms/RichText/RichText'
const RichText: React.VFC<{ title: string; htmlString: string }> = ({
    title,
    htmlString,
}) => {
    return (
        <Container css={{ paddingTop: '$xl' }}>
            <Padder top="md">
                <RichTextComponent
                    htmlString={`<h1>${title}</h1>`}
                    textVariant="titleMedium"
                />
                <RichTextComponent
                    htmlString={htmlString}
                    textVariant="small2"
                />
            </Padder>
        </Container>
    )
}

export default RichText
